// extracted by mini-css-extract-plugin
export var alt = "ParagraphPartnershipBrands-module--alt--3fba6";
export var container = "ParagraphPartnershipBrands-module--container--ae1e7";
export var desktopOnly = "ParagraphPartnershipBrands-module--desktopOnly--17839";
export var main = "ParagraphPartnershipBrands-module--main--9aa69";
export var mobileOnly = "ParagraphPartnershipBrands-module--mobileOnly--98de5";
export var textLeft = "ParagraphPartnershipBrands-module--textLeft--e50b5";
export var visuallyHidden = "ParagraphPartnershipBrands-module--visuallyHidden--bf2eb";